import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role === "fan" ? "/account" : "/admin");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-obsidian">
      <Crown className="h-10 w-10 text-gold animate-pulse" />
      <p className="flex items-center gap-2 text-amber-100/70"><Loader2 className="h-4 w-4 animate-spin" /> Signing you in…</p>
    </div>
  );
}
